import { ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'

//详情
export interface IDangerDetail {
    id?: string
    prefix?: string
    shopId?: string
    shopCode?: string
    shopName?: string
    branch?: string
    ver?: string
    enable?: string
    orgCode?: string
    orgName?: string
    contact?: string
    phone?: string
    address?: string
    status?: number | boolean
    sourceApp?: string
    categoryName?: string
    typeCode?: string
    typeName?: string
    suffixNum?: number
    settingType?: string
    isYear?: number
    isMonth?: number
    isDate?: number
    style?: string
    note?: string
    dangerNum?: number
    traceId?: string
    deleteFlag?: number
    createTime?: string
    updateTime?: string
    createUser?: string
    updateUser?: string
    [key: string]: any
}
//新增
export interface IDangerInsert {
    prefix?: string // "ad reprehenderit magna in",
    suffixNum?: number // 22,
    settingType?: string // "CALCULATE",
    isYear?: number // 55,
    isMonth?: number // 59,
    isDate?: number // 20180911,
    note?: string // "veniam sint laborum tempor",
    style?: string // "incididunt"
}

//编辑
export interface IDangerUpdate extends IDangerInsert {
    id?: string
}
//搜索条件
export interface IDangerSearchFields {
    startTime?: string
    endTime?: string
    [key: string]: any
}

export interface IDangerSearch extends IDangerSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch extends IDangerSearchFields, ISearchPage {}

class DangerService {
    async page(searchVo: IDangerSearch, config: object = {}) {
        const apiUrl = '/threeInspection/scheduling/item/hidden/list'
        return await httpRequest.post<any>(apiUrl, searchVo, config)
    }
    async insert(searchVo: IDangerSearchFields) {
        const apiUrl = '/threeInspection/scheduling/insert'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async edit(searchVo: IDangerSearchFields) {
        const apiUrl = '/threeInspection/scheduling/update'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async onDelete(searchVo: IDangerSearchFields) {
        const apiUrl = '/threeInspection/scheduling/delete'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async sendNotifications(searchVo: IDangerSearchFields) {
        const apiUrl = '/threeInspection/scheduling/notice'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async one(searchVo: IDangerSearchFields) {
        const apiUrl = '/threeInspection/log/list'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async orderLogs(searchVo: IDangerSearchFields) {
        const apiUrl = '/threeInspection/ciOrder/progress_log/list'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async getDangerImg(updateVo: IDangerUpdate) {
        const apiUrl = '/threeInspection/ciOrder/list_for_group'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async getImageClassifyList(updateVo: IDangerUpdate) {
        const apiUrl = '/threeInspection/ciOrder/list_for_group'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }

    async assignMaintenance(updateVo: any) {
        const apiUrl = '/threeInspection/scheduling/item/mainTech'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }

    async adminFinish(updateVo: any) {
        const apiUrl = '/threeInspection/scheduling/item/confirm'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    //更新隐患金额
    async updateAmount(updateVo: any) {
        const apiUrl = '/threeInspection/scheduling/item/update/amount'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }

    //导出隐患台账列表数据
    async exportList(searchVo: any) {
        const appPageUrl = '/threeInspection/scheduling/item/hidden/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }

    // ===== 巡查员隐患相关接口 =====
    // 巡查员隐患列表查询
    async inspectionPage(searchVo: any, config: object = {}) {
        const apiUrl = '/threeInspection/inspection/hazards/list'
        return await httpRequest.post<any>(apiUrl, searchVo, config)
    }
    // 巡查员提交隐患
    async inspectionInsert(searchVo: any) {
        const apiUrl = '/threeInspection/inspection/hazards/insert'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    // 车队长分配维修技师（巡查员）
    async inspectionAssignMaintainer(searchVo: any) {
        const apiUrl = '/threeInspection/inspection/hazards/mainTech'
        return await httpRequest.post<boolean>(apiUrl, searchVo)
    }
    // 维修技师提交完成（巡查员）
    async inspectionRepairCompleted(searchVo: any) {
        const apiUrl = '/threeInspection/inspection/hazards/repairCompleted'
        return await httpRequest.post<boolean>(apiUrl, searchVo)
    }
    // 车队长确认隐患（巡查员）
    async inspectionConfirm(searchVo: any) {
        const apiUrl = '/threeInspection/inspection/hazards/confirm'
        return await httpRequest.post<boolean>(apiUrl, searchVo)
    }
    // 查看单条隐患详情（巡查员）
    async inspectionOne(searchVo: any) {
        const apiUrl = '/threeInspection/inspection/hazards/one'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    // 查看日志（巡查员）
    async inspectionLogList(searchVo: any) {
        const apiUrl = '/threeInspection/log/inspection/list'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    // 查询车队列表
    async queryInstitutionList(searchVo: any) {
        const apiUrl = '/threeInspection/institution/list'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    // 查询隐患关联的工单列表
    async hiddenOrderList(searchVo: any) {
        const apiUrl = '/threeInspection/ciOrder/order/hiddenList'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
}

export const dangerService = new DangerService()
